import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  const services = [
    { label: 'Frameless Shower Doors', path: '/services' },
    { label: 'Sliding Glass Doors', path: '/services' },
    { label: 'Tub Enclosures', path: '/services' },
    { label: 'Glass Railings', path: '/services' },
    { label: 'Stair Glass', path: '/services' },
    { label: 'Custom Mirrors', path: '/services' },
    { label: 'Glass Partitions', path: '/services' },
    { label: 'Window Glass', path: '/services' },
  ];

  const areas = [
    { label: 'Las Vegas', path: '/service-areas' },
    { label: 'Henderson', path: '/service-areas' },
    { label: 'North Las Vegas', path: '/service-areas' },
    { label: 'Summerlin', path: '/service-areas' },
    { label: 'Spring Valley', path: '/service-areas' },
    { label: 'Paradise', path: '/service-areas' },
  ];

  const company = [
    { label: 'About Us', path: '/about' },
    { label: 'Gallery', path: '/gallery' },
    { label: 'Reviews', path: '/reviews' },
    { label: 'Blog', path: '/blog' },
    { label: 'Contact', path: '/contact' },
    { label: 'Free Quote', path: '/free-quote' },
  ];

  return (
    <footer className="bg-[#0A0A0A] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="cursor-pointer inline-block mb-4">
              <img src="https://public.readdy.ai/ai/img_res/bec85c6e-a88e-49c5-9451-4240e50efb42.png" alt="Quinolux Glass & Mirrors" className="h-14 w-auto object-contain" />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed max-w-sm mb-8">{t('footerDesc')}</p>
            <div className="flex items-center gap-4">
              <a href="tel:+17026042093" className="flex items-center gap-2 text-sm text-white border border-gray-700 px-4 py-2 rounded-full hover:border-white transition-colors duration-300 cursor-pointer whitespace-nowrap">
                <i className="ri-phone-line"></i> (702) 604-2093
              </a>
            </div>
            <div className="flex items-center gap-4 mt-6">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-700 text-gray-400 hover:text-white hover:border-white transition-all duration-300 cursor-pointer"><i className="ri-facebook-fill text-sm"></i></a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-700 text-gray-400 hover:text-white hover:border-white transition-all duration-300 cursor-pointer"><i className="ri-instagram-line text-sm"></i></a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-700 text-gray-400 hover:text-white hover:border-white transition-all duration-300 cursor-pointer"><i className="ri-google-fill text-sm"></i></a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-white mb-6">{t('footerServices')}</h4>
            <ul className="space-y-3">
              {services.map(s => (
                <li key={s.label}>
                  <Link to={s.path} className="text-gray-400 text-sm hover:text-white transition-colors duration-300 cursor-pointer">{s.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Areas */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-white mb-6">{t('footerAreas')}</h4>
            <ul className="space-y-3">
              {areas.map(a => (
                <li key={a.label}>
                  <Link to={a.path} className="text-gray-400 text-sm hover:text-white transition-colors duration-300 cursor-pointer">{a.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-white mb-6">{t('footerCompany')}</h4>
            <ul className="space-y-3">
              {company.map(c => (
                <li key={c.label}>
                  <Link to={c.path} className="text-gray-400 text-sm hover:text-white transition-colors duration-300 cursor-pointer">{c.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-600 text-xs">&copy; {new Date().getFullYear()} Quinolux Glass &amp; Mirrors. {t('footerRights')}</p>
          <div className="flex items-center gap-6">
            <Link to="/contact" className="text-gray-600 text-xs hover:text-gray-400 transition-colors cursor-pointer">{t('privacy')}</Link>
            <Link to="/contact" className="text-gray-600 text-xs hover:text-gray-400 transition-colors cursor-pointer">{t('terms')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
